import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";

import store from "./reducers/store";
import App from "./App";

import { ThemeProvider, createTheme } from "@mui/material/styles";

console.log2 = console.log;
console.log = () => {};

const theme = createTheme({
  // typography: {
  //   fontFamily: ['DM Sans'].join(','),
  //   button: {
  //     textTransform: 'none',
  //     letterSpacing: 1,
  //     fontSize: '14px',
  //   }
  // },
  // palette: {
  //   primary: {
  //     main: '#5721F1',
  //     light: '#F2F5FF',
  //     dark: '#250E63',
  //     darker: '#0B1C2F',
  //   }
  // },
  breakpoints: {
    values: {
      xs: 0,
      sm: 510,
      md: 768,
      lg: 1024,
      xl: 1536,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        disableElevation: true,
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OATH}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </GoogleOAuthProvider>
);
